import api from '../../plugins/api';

const createClient = (params) => {
  return api.uploadFile('/api/crm/clients/createClient', params);
};

export default createClient;
